<script setup>
import { ref, onMounted, computed } from 'vue';
import DOMPurify from 'dompurify';

const props = defineProps({
  presenterDescription: String,
  presenterImage: String,
  presenterName: String,
  presenterTitle: String,
});

// Computed properties for sanitized content
const sanitizedDescription = computed(() => {
  return props.presenterDescription
    ? DOMPurify.sanitize(props.presenterDescription)
    : '';
});

const sanitizedName = computed(() => {
  return props.presenterName ? DOMPurify.sanitize(props.presenterName) : '';
});

const sanitizedTitle = computed(() => {
  return props.presenterTitle ? DOMPurify.sanitize(props.presenterTitle) : '';
});

const sanitizedImage = computed(() => {
  return props.presenterImage ? DOMPurify.sanitize(props.presenterImage) : '';
});
</script>

<template>
  <div class="testimonial-card">
    <div class="testimonial-image" >
      <img :src="sanitizedImage" alt="Presenter Image" class="profile-image" />
      <div class="testimonial-titles" >
        <div>
          <p class="testimonial-name" v-html="sanitizedName"></p>
          <p class="testimonial-title" v-html="sanitizedTitle"></p>
        </div>
      </div>
    </div>
    <div class="testimonial-content">
      <div class="testimonial-details">
        <div>
          <p class="testimonial-name" v-html="sanitizedName"></p>
          <p class="testimonial-title" v-html="sanitizedTitle"></p>
        </div>
      </div>
      <p class="testimonial-message" v-html="sanitizedDescription"></p>
    </div>
  </div>
</template>

<style scoped>
.testimonial-card {
  display: flex;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  padding: 1rem;
}

/* testimonal grid card */
/* .testimonial-card {
  max-width: 300px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  padding: 1rem;
} */

.testimonial-image {
  flex: 0 0 150px;
  position: relative;
 
  display: flex;
  flex-direction: row;
}
.testimonial-titles{
  display: none;
}

.profile-image {
  height: 100%;
  max-height: 200px;
  border-radius: 10px;
  margin-right: 2rem;
  object-fit: cover;
  aspect-ratio: 1;
  background-color: red;
}

.testimonial-content {
  flex: 1;
  position: relative;
}

.quote-icon {
  font-size: 3rem;
  color: #d3d3d3;
  position: absolute;
  top: 20px;
  left: 20px;
}

.testimonial-message {
  font-family: 'Lora', serif;
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
  padding-top: 1rem;
  line-height: 1.5;
}

.testimonial-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
 
}

.testimonial-name {
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
}

.testimonial-title {
  font-size: 14px;
  color: #666;
}

@media (max-width: 768px) {
  .testimonial-card {
    flex-direction: column;
  }

  .testimonial-image {
    flex: 0 0 0px;
    align-items: center;
    
  }
  .testimonial-titles{
    display: block;
    justify-content: center;
    flex-wrap: wrap;


  }
  .testimonial-message {
    margin-top: 1rem;
    font-size: 14px;
  }
  .testimonial-details{
    display: none;
  }
  .testimonial-name {
    font-size: 14px;
    padding-top: 0;
  }

  .testimonial-title {
    font-size: 12px;
  }
  .profile-image{
    height: 100px;
    margin-right: 1rem;
  }
}
@media (max-width: 590px) {
  
  
  .profile-image{
    height: 60px;
  }
 
  .testimonial-name {
    font-size: 14px;
  }

  .testimonial-title {
    font-size: 12px;
  }
}
</style>
